import { Card, CardContent, CardMedia, InputAdornment, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid/Grid'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import { Alert } from '@material-ui/lab'
import classNames from 'classnames'
import clsx from 'clsx'
import SubmitButton, { SubmitButtonProps } from 'components/common/submitButton'
import { useImgix } from 'core/services/imgix/useImgix'
import React, { useState } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { Form, FormSpy } from 'react-final-form'
import { Trans, useTranslation } from 'react-i18next'
import withDnD from '../../../containers/hoc/withDnD'
import CheckboxField from '../components/checkboxField'
import HiddenField from '../components/hiddenField'
import ImageField from '../components/imageField'
import SelectField, { SelectValue } from '../components/selectField'
import TextField from '../components/textField'
import { useFormsStyles } from '../forms.css'
import { moveArrayItemToNewIndex } from '../helpers/moveArrayItemToNewIndex'
import { Image } from '../helpers/useImages'
import { useStyles } from './websiteCustomizationForm.css'

interface Props {
    subscription?: { [property: string]: boolean }
    onSubmit: (values: WebsiteCustomizationFormState, withClose: boolean) => void
    children: (
        content: React.ReactNode,
        actions: Array<SubmitButtonProps>,
        prepend?: React.ReactNode,
    ) => React.ReactNode
    formClassName?: string
    inProgress: boolean
    initialValues: WebsiteCustomizationFormState
}

export interface WebsiteCustomizationFormState {
    backgroundColorLight?: string
    backgroundColorDark?: string
    font?: string

    titleSectionTextColor?: string
    titleSectionBackgroundColor?: string
    titleSectionTextColorEnabled: boolean[]
    titleSectionBackgroundColorEnabled: boolean[]
    titleSectionBackgroundImage?: Image
    titleSectionOverlayOpacity?: number
    titleSectionOverlayOpacityEnabled: boolean[]
    titleSectionHidden: boolean
    titleSectionSortOrder: number

    slateSectionTextColor?: string
    slateSectionBackgroundColor?: string
    slateSectionTextColorEnabled: boolean[]
    slateSectionBackgroundColorEnabled: boolean[]
    slateSectionBackgroundImage?: Image
    slateSectionOverlayOpacity?: number
    slateSectionOverlayOpacityEnabled: boolean[]
    slateSectionHidden: boolean
    slateSectionSortOrder: number

    menuSectionTextColor?: string
    menuSectionBackgroundColor?: string
    menuSectionTextColorEnabled: boolean[]
    menuSectionBackgroundColorEnabled: boolean[]
    menuSectionBackgroundImage?: Image
    menuSectionOverlayOpacity?: number
    menuSectionOverlayOpacityEnabled: boolean[]
    menuSectionHidden: boolean
    menuSectionSortOrder: number

    newsSectionTextColor?: string
    newsSectionBackgroundColor?: string
    newsSectionTextColorEnabled: boolean[]
    newsSectionBackgroundColorEnabled: boolean[]
    newsSectionBackgroundImage?: Image
    newsSectionOverlayOpacity?: number
    newsSectionOverlayOpacityEnabled: boolean[]
    newsSectionHidden: boolean
    newsSectionSortOrder: number

    aboutSectionTextColor?: string
    aboutSectionBackgroundColor?: string
    aboutSectionTextColorEnabled: boolean[]
    aboutSectionBackgroundColorEnabled: boolean[]
    aboutSectionBackgroundImage?: Image
    aboutSectionOverlayOpacity?: number
    aboutSectionOverlayOpacityEnabled: boolean[]
    aboutSectionHidden: boolean
    aboutSectionSortOrder: number

    linksSectionTextColor?: string
    linksSectionBackgroundColor?: string
    linksSectionTextColorEnabled: boolean[]
    linksSectionBackgroundColorEnabled: boolean[]
    linksSectionBackgroundImage?: Image
    linksSectionOverlayOpacity?: number
    linksSectionOverlayOpacityEnabled: boolean[]
    linksSectionHidden: boolean
    linksSectionSortOrder: number

    bookSectionTextColor?: string
    bookSectionBackgroundColor?: string
    bookSectionTextColorEnabled: boolean[]
    bookSectionBackgroundColorEnabled: boolean[]
    bookSectionBackgroundImage?: Image
    bookSectionOverlayOpacity?: number
    bookSectionOverlayOpacityEnabled: boolean[]
    bookSectionHidden: boolean
    bookSectionSortOrder: number

    orderSectionTextColor?: string
    orderSectionBackgroundColor?: string
    orderSectionTextColorEnabled: boolean[]
    orderSectionBackgroundColorEnabled: boolean[]
    orderSectionBackgroundImage?: Image
    orderSectionOverlayOpacity?: number
    orderSectionOverlayOpacityEnabled: boolean[]
    orderSectionHidden: boolean
    orderSectionSortOrder: number

    photosSectionTextColor?: string
    photosSectionBackgroundColor?: string
    photosSectionTextColorEnabled: boolean[]
    photosSectionBackgroundColorEnabled: boolean[]
    photosSectionBackgroundImage?: Image
    photosSectionOverlayOpacity?: number
    photosSectionOverlayOpacityEnabled: boolean[]
    photosSectionHidden: boolean
    photosSectionSortOrder: number

    informationSectionTextColor?: string
    informationSectionBackgroundColor?: string
    informationSectionTextColorEnabled: boolean[]
    informationSectionBackgroundColorEnabled: boolean[]
    informationSectionBackgroundImage?: Image
    informationSectionOverlayOpacity?: number
    informationSectionOverlayOpacityEnabled: boolean[]
    informationSectionHidden: boolean
    informationSectionSortOrder: number

    reviewsSectionTextColor?: string
    reviewsSectionBackgroundColor?: string
    reviewsSectionTextColorEnabled: boolean[]
    reviewsSectionBackgroundColorEnabled: boolean[]
    reviewsSectionBackgroundImage?: Image
    reviewsSectionOverlayOpacity?: number
    reviewsSectionOverlayOpacityEnabled: boolean[]
    reviewsSectionHidden: boolean
    reviewsSectionSortOrder: number

    footerSectionTextColor?: string
    footerSectionBackgroundColor?: string
    footerSectionTextColorEnabled: boolean[]
    footerSectionBackgroundColorEnabled: boolean[]
    footerSectionBackgroundImage?: Image
    footerSectionOverlayOpacity?: number
    footerSectionOverlayOpacityEnabled: boolean[]
    footerSectionHidden: boolean
    footerSectionSortOrder: number
}

export interface WebsiteCustomizationFormError {
    backgroundColorLight?: string
    backgroundColorDark?: string
    font?: string

    titleSectionTextColor?: string
    titleSectionBackgroundColor?: string
    titleSectionBackgroundImage?: string
    titleSectionOverlayOpacity?: string

    slateSectionTextColor?: string
    slateSectionBackgroundColor?: string
    slateSectionBackgroundImage?: string
    slateSectionOverlayOpacity?: string

    menuSectionTextColor?: string
    menuSectionBackgroundColor?: string
    menuSectionBackgroundImage?: string
    menuSectionOverlayOpacity?: string

    newsSectionTextColor?: string
    newsSectionBackgroundColor?: string
    newsSectionBackgroundImage?: string
    newsSectionOverlayOpacity?: string

    aboutSectionTextColor?: string
    aboutSectionBackgroundColor?: string
    aboutSectionBackgroundImage?: string
    aboutSectionOverlayOpacity?: string

    linksSectionTextColor?: string
    linksSectionBackgroundColor?: string
    linksSectionBackgroundImage?: string
    linksSectionOverlayOpacity?: string

    bookSectionTextColor?: string
    bookSectionBackgroundColor?: string
    bookSectionBackgroundImage?: string
    bookSectionOverlayOpacity?: string

    orderSectionTextColor?: string
    orderSectionBackgroundColor?: string
    orderSectionBackgroundImage?: string
    orderSectionOverlayOpacity?: string

    photosSectionTextColor?: string
    photosSectionBackgroundColor?: string
    photosSectionBackgroundImage?: string
    photosSectionOverlayOpacity?: string

    informationSectionTextColor?: string
    informationSectionBackgroundColor?: string
    informationSectionBackgroundImage?: string
    informationSectionOverlayOpacity?: string

    reviewsSectionTextColor?: string
    reviewsSectionBackgroundColor?: string
    reviewsSectionBackgroundImage?: string
    reviewsSectionOverlayOpacity?: string

    footerSectionTextColor?: string
    footerSectionBackgroundColor?: string
    footerSectionBackgroundImage?: string
    footerSectionOverlayOpacity?: string
}

interface SectionPartProps {
    initialValues: WebsiteCustomizationFormState
    section: string
    sortOrderUpdate: boolean
    index: number
    moveEntry: (from: number, to: number) => void
}

const SectionPart: React.FC<SectionPartProps> = ({
    initialValues,
    section,
    sortOrderUpdate,
    index,
    moveEntry,
}) => {
    const { t } = useTranslation()
    const formsClasses = useFormsStyles()
    const classes = useStyles()

    const { getImage } = useImgix()

    const [{ isDragging }, drag] = useDrag<any, any, { isDragging: boolean }>({
        type: ItemTypes.SECTION,
        item: { index: index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const [{ isOver }, drop] = useDrop({
        accept: ItemTypes.SECTION,
        // @ts-ignore
        drop: (item) => moveEntry(item.index, index),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    })
    return (
        <FormSpy subscription={{ values: true }}>
            {(props) => (
                <Grid
                    item
                    md={4}
                    sm={6}
                    xs={12}
                    ref={sortOrderUpdate && section !== 'title' && section !== 'footer' ? drop : undefined}
                    className={classNames({
                        [classes.over]: isOver,
                    })}
                >
                    <Card
                        ref={
                            sortOrderUpdate && section !== 'title' && section !== 'footer' ? drag : undefined
                        }
                        className={clsx({
                            [classes.dragged]: isDragging,
                        })}
                    >
                        <div
                            className={clsx(classes.sectionTitleContainer, {
                                [classes.sectionHidden]:
                                    sortOrderUpdate && (section === 'title' || section === 'footer'),
                            })}
                        >
                            <div className={clsx(classes.sectionTitleNumber)}>
                                <Typography>{index + 1}</Typography>
                            </div>
                            <Typography className={classes.sectionTitle}>
                                <Trans
                                    i18nKey={'views.externalLinks.customization.section.' + section}
                                    components={[<strong />]}
                                />
                            </Typography>
                            <div
                                className={clsx(classes.sectionTitleAddon, {
                                    [classes.hidden]:
                                        sortOrderUpdate || section === 'title' || section === 'footer',
                                })}
                            >
                                <HiddenField name={section + 'SectionHidden'} />
                            </div>
                        </div>
                        <CardContent
                            className={clsx({
                                [classes.hidden]: sortOrderUpdate,
                                [classes.sectionHidden]: props.values[section + 'SectionHidden'],
                            })}
                        >
                            <TextField
                                label={t('views.externalLinks.customization.backgroundColor')}
                                name={section + 'SectionBackgroundColor'}
                                type="color"
                                className={
                                    props.values[section + 'SectionBackgroundColorEnabled'].length === 0
                                        ? classes.disabled
                                        : ''
                                }
                                disabled={
                                    props.values[section + 'SectionBackgroundColorEnabled'].length === 0
                                }
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <CheckboxField
                                                value={true}
                                                label={t('views.externalLinks.customization.active')}
                                                name={section + 'SectionBackgroundColorEnabled'}
                                                labelPlacement="end"
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                label={t('views.externalLinks.customization.overlayOpacity')}
                                name={section + 'SectionOverlayOpacity'}
                                type="number"
                                inputProps={{
                                    min: 0,
                                    max: 1,
                                    step: '.01',
                                }}
                                className={
                                    props.values[section + 'SectionOverlayOpacityEnabled'].length === 0
                                        ? classes.disabled
                                        : ''
                                }
                                disabled={props.values[section + 'SectionOverlayOpacityEnabled'].length === 0}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <CheckboxField
                                                value={true}
                                                label={t('views.externalLinks.customization.active')}
                                                name={section + 'SectionOverlayOpacityEnabled'}
                                                labelPlacement="end"
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                label={t('views.externalLinks.customization.textColor')}
                                name={section + 'SectionTextColor'}
                                type="color"
                                className={
                                    props.values[section + 'SectionTextColorEnabled'].length === 0
                                        ? classes.disabled
                                        : ''
                                }
                                disabled={props.values[section + 'SectionTextColorEnabled'].length === 0}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <CheckboxField
                                                value={true}
                                                label={t('views.externalLinks.customization.active')}
                                                name={section + 'SectionTextColorEnabled'}
                                                labelPlacement="end"
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <ImageField
                                name={section + 'SectionBackgroundImage'}
                                label={t('views.externalLinks.customization.backgroundImage')}
                                defaultValue={
                                    // @ts-ignore
                                    initialValues[section + 'SectionBackgroundImage']
                                }
                                imageOptions={{
                                    maxWidth: 120,
                                }}
                            >
                                {(Uploader, hasError, error, image, onDelete) => {
                                    return (
                                        <div className={classes.photoField}>
                                            <Uploader
                                                classes={{
                                                    root: clsx(formsClasses.photoField),
                                                    container: formsClasses.photoFieldContainer,
                                                }}
                                            >
                                                <Card
                                                    elevation={0}
                                                    classes={{
                                                        root: image
                                                            ? formsClasses.photoFieldCard
                                                            : formsClasses.photoFieldCardWithoutImage,
                                                    }}
                                                >
                                                    <CardMedia
                                                        image={
                                                            image?.url &&
                                                            getImage(image?.url, {
                                                                w: 120,
                                                                ar: '1:1',
                                                                fit: 'clip',
                                                            })
                                                        }
                                                        classes={{
                                                            root: clsx(formsClasses.photoFieldCardMedia),
                                                        }}
                                                    >
                                                        {!image && (
                                                            <div
                                                                className={
                                                                    formsClasses.photoFieldAddContainer
                                                                }
                                                            >
                                                                <AddCircleIcon
                                                                    className={clsx(
                                                                        formsClasses.photoFieldAdd,
                                                                        classes.photoFieldAdd,
                                                                    )}
                                                                    color="primary"
                                                                />
                                                            </div>
                                                        )}
                                                    </CardMedia>
                                                </Card>
                                                {image?.url && (
                                                    <div className={classes.photoEdit}>
                                                        <Button variant="contained" color="primary" fullWidth>
                                                            <Trans i18nKey="actions.edit" />
                                                        </Button>
                                                    </div>
                                                )}
                                            </Uploader>
                                            {image?.url && (
                                                <div className={classes.photoDelete}>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={onDelete}
                                                        fullWidth
                                                    >
                                                        <Trans i18nKey="actions.delete" />
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    )
                                }}
                            </ImageField>
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </FormSpy>
    )
}

export const ItemTypes = {
    SECTION: 'section',
}
const WebsiteCustomizationForm: React.FC<Props> = ({
    subscription = {
        submitting: true,
        pristine: true,
        values: true,
        errors: true,
        submitFailed: true,
    },
    onSubmit,
    children,
    formClassName,
    inProgress,
    initialValues,
}) => {
    const { t } = useTranslation()
    const formsClasses = useFormsStyles()
    const submit = (values: WebsiteCustomizationFormState, withClose = true) => {
        return onSubmit(values, withClose)
    }
    const [sectionOrder, setSectionOrder] = useState(() => {
        const defaultOrder = [
            'title',
            'slate',
            'menu',
            'news',
            'about',
            'links',
            'book',
            'order',
            'photos',
            'information',
            'reviews',
            'footer',
        ]

        defaultOrder.sort((section1, section2) => {
            if (
                // @ts-ignore
                initialValues[section1 + 'SectionSortOrder'] === initialValues[section2 + 'SectionSortOrder']
            ) {
                return 0
            }
            // @ts-ignore
            return initialValues[section1 + 'SectionSortOrder'] > initialValues[section2 + 'SectionSortOrder']
                ? 1
                : -1
        })

        return defaultOrder
    })

    const possibilities: SelectValue[] = [
        { label: 'Open Sans', value: 'Open Sans' },
        { label: 'Roboto', value: 'Roboto' },
        { label: 'Inclusive Sans', value: 'Inclusive Sans' },
        { label: 'Coiny', value: 'Coiny' },
        { label: 'Noto Serif', value: 'Noto Serif' },
        { label: 'Josefin Sans', value: 'Josefin Sans' },
        { label: 'Oregano', value: 'Oregano' },
        { label: 'Sumana', value: 'Sumana' },
        { label: 'Sigmar', value: 'Sigmar' },
        { label: 'Stick No Bills', value: 'Stick No Bills' },
        { label: 'Belanosima', value: 'Belanosima' },
        { label: 'MuseoModerno', value: 'MuseoModerno' },
    ]
    if (
        initialValues.font &&
        possibilities.find((possibility) => possibility.value === initialValues.font) === undefined
    ) {
        possibilities.push({
            label: initialValues.font,
            value: initialValues.font,
        })
    }
    const validate = (values: WebsiteCustomizationFormState) => {
        const errors: WebsiteCustomizationFormError = {}
        sectionOrder.forEach((section) => {
            if (
                // @ts-ignore
                values[section + 'SectionOverlayOpacityEnabled'].length > 0 &&
                // @ts-ignore
                values[section + 'SectionOverlayOpacity'] &&
                // @ts-ignore
                (values[section + 'SectionOverlayOpacity'] > 1 ||
                    // @ts-ignore
                    values[section + 'SectionOverlayOpacity'] < 0)
            ) {
                // @ts-ignore
                errors[section + 'SectionOverlayOpacity'] = t('form-validation.overlayOpacity')
            }
        })
        return errors
    }

    const [sortOrderUpdate, setSortOrderUpdate] = useState(false)
    return (
        <Form
            initialValues={initialValues}
            subscription={subscription}
            mutators={{
                updateSortOrder: (args, state, tools) => {
                    const newSectionOrder = args[0] as string[]
                    newSectionOrder.forEach((section, index) => {
                        tools.changeValue(state, section + 'SectionSortOrder', () => index + 1)
                    })
                },
            }}
            // debug={console.log}
            onSubmit={(values) => submit(values)}
            validate={validate}
            keepDirtyOnReinitialize
        >
            {({ handleSubmit, submitting, form: { mutators }, values, errors, submitFailed }) => {
                const moveEntry = (from: number, to: number) => {
                    const newSectionOrder = moveArrayItemToNewIndex(sectionOrder, from, to)
                    mutators.updateSortOrder(newSectionOrder)
                    setSectionOrder([...newSectionOrder])
                }
                const updateSortOrder = async () => {
                    if (sortOrderUpdate) {
                        const errors = validate(values)
                        if (Object.keys(errors).length === 0) {
                            submit(values, false)
                        } else {
                            handleSubmit()
                        }
                    }
                    setSortOrderUpdate(!sortOrderUpdate)
                }
                return (
                    <form onSubmit={handleSubmit} noValidate className={formClassName}>
                        {children(
                            <div>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <SelectField
                                            name="font"
                                            label={t('views.externalLinks.customization.websiteFont')}
                                            variant="standard"
                                            possibilities={possibilities.map((possibility) => ({
                                                ...possibility,
                                                style: {
                                                    fontFamily: [
                                                        possibility.value,
                                                        'Open Sans',
                                                        'sans-serif',
                                                    ].join(','),
                                                },
                                            }))}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container className={formsClasses.websiteBackground}>
                                            <Grid item xs={6} className={formsClasses.paddingRight}>
                                                <TextField
                                                    label={t(
                                                        'views.externalLinks.customization.websiteBackgroundColorLight',
                                                    )}
                                                    name={'backgroundColorLight'}
                                                    type="color"
                                                />
                                            </Grid>
                                            <Grid item xs={6} className={formsClasses.paddingLeft}>
                                                <TextField
                                                    label={t(
                                                        'views.externalLinks.customization.websiteBackgroundColorDark',
                                                    )}
                                                    name={'backgroundColorDark'}
                                                    type="color"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography variant="caption" paragraph>
                                                    <Trans i18nKey="views.externalLinks.customization.websiteBackgroundHelp" />
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={4} justifyContent="flex-end">
                                    <Grid item>
                                        <SubmitButton
                                            variant={!sortOrderUpdate ? 'contained' : 'outlined'}
                                            color="primary"
                                            onClick={updateSortOrder}
                                            loading={inProgress}
                                        >
                                            {!sortOrderUpdate ? (
                                                <Trans i18nKey="views.externalLinks.customization.updateSortOrder" />
                                            ) : (
                                                <Trans i18nKey="views.externalLinks.customization.updateSortOrderStop" />
                                            )}
                                        </SubmitButton>
                                    </Grid>
                                    {sortOrderUpdate && (
                                        <Grid item xs={12}>
                                            <Alert severity="info">
                                                <Trans i18nKey="views.externalLinks.customization.updateSortOrderHelper" />
                                            </Alert>
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid container spacing={4}>
                                    {sectionOrder.map((section, index) => (
                                        <SectionPart
                                            key={section}
                                            initialValues={initialValues}
                                            section={section}
                                            sortOrderUpdate={sortOrderUpdate}
                                            index={index}
                                            moveEntry={moveEntry}
                                        />
                                    ))}
                                </Grid>
                            </div>,
                            [
                                {
                                    type: 'submit',
                                    loading: submitting || inProgress,
                                    className: formsClasses.submit,
                                    children: <Trans i18nKey="actions.next" />,
                                },
                            ],
                            <>
                                {submitFailed && errors && Object.keys(errors).length > 0 && (
                                    <Alert severity="error" className={formsClasses.errors}>
                                        {Object.keys(errors).length === 1 ? (
                                            <>{errors[Object.keys(errors)[0]]}</>
                                        ) : (
                                            <Trans i18nKey="form.validationFailed" />
                                        )}
                                    </Alert>
                                )}
                            </>,
                        )}
                    </form>
                )
            }}
        </Form>
    )
}
export default withDnD(WebsiteCustomizationForm)
